export const SET_TOASTIFY = 'SET_TOASTIFY';
